import { lazy } from 'react';

const AddRecordPage = lazy(() => import('./AddRecord/AddRecord'));
const ViewRecordPage = lazy(() => import('./ViewRecord/ViewRecord'));
const EditRecordPage = lazy(() => import('./EditRecord/EditRecord'));
const AcceptRequestForDecisionPage = lazy(
  () => import('./AcceptRequestForDecision/AcceptRequestForDecision')
);
const RejectRequestForDecisionPage = lazy(
  () => import('./RejectRequestForDecision/RejectRequestForDecision')
);
const EditRequestForDecisionPage = lazy(
  () => import('./EditRequestForDecision/EditRequestForDecision')
);
const AddRequestInfoPage = lazy(() => import('./AddRequestInfo/AddRequestInfo'));
const EditRequestInfoPage = lazy(() => import('./EditRequestInfo/EditRequestInfo'));
const EditActionRequestPage = lazy(() => import('./EditActionRequest/EditActionRequest'));
const AddActionInfoPage = lazy(() => import('./AddActionInfo/AddActionInfo'));
const EditActionInfoPage = lazy(() => import('./EditActionInfo/EditActionInfo'));
const AddRequestProlongationInfoPage = lazy(
  () => import('./AddRequestProlongationInfo/AddRequestProlongationInfo')
);
const EditRequestProlongationInfoPage = lazy(
  () => import('./EditRequestProlongationInfo/EditRequestProlongationInfo')
);
const AcceptProlongationPage = lazy(() => import('./AcceptProlongation/AcceptProlongation'));
const RejectProlongationPage = lazy(() => import('./RejectProlongation/RejectProlongation'));
const AddRequestVGNKIPage = lazy(() => import('./AddRequestVGNKI/AddRequestVGNKI'));
const EditRequestVGNKIPage = lazy(() => import('./EditRequestVGNKI/EditRequestVGNKI'));
const AddVGNKIDecisionPage = lazy(() => import('./AddVGNKIDecision/AddVGNKIDecision'));
const EditVGNKIDecisionPage = lazy(() => import('./EditVGNKIDecision/EditVGNKIDecision'));
const AddReviewResultPage = lazy(() => import('./AddReviewResult/AddReviewResult'));
const EditReviewResultPage = lazy(() => import('./EditReviewResult/EditReviewResult'));

export {
  AddRecordPage,
  ViewRecordPage,
  EditRecordPage,
  AcceptRequestForDecisionPage,
  RejectRequestForDecisionPage,
  EditRequestForDecisionPage,
  AddRequestInfoPage,
  EditRequestInfoPage,
  EditActionRequestPage,
  AddActionInfoPage,
  EditActionInfoPage,
  AddRequestProlongationInfoPage,
  EditRequestProlongationInfoPage,
  AcceptProlongationPage,
  RejectProlongationPage,
  AddRequestVGNKIPage,
  EditRequestVGNKIPage,
  AddVGNKIDecisionPage,
  EditVGNKIDecisionPage,
  AddReviewResultPage,
  EditReviewResultPage,
};
